module.exports = __webpack_public_path__ + "static/media/social.feab8441.png";